import { useToast } from 'primevue/usetoast'

export function useGlobalToast() {
  const toast = useToast()

  function add(options: Record<string, unknown>) {
    toast.add({
      life: 5000,
      ...options // пользовательские параметры в приоритете
    })
  }

  return {
    ...toast,
    add
  }
}
